declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Read the GA4 client_id via gtag('get', measurementId, 'client_id', cb)
 * with a hard timeout. Resolves undefined when gtag is missing, blocked,
 * or fails to call back within timeoutMs.
 */
export function getGA4ClientId(
  measurementId: string,
  timeoutMs = 500
): Promise<string | undefined> {
  if (typeof window === 'undefined' || !measurementId) return Promise.resolve(undefined);
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return Promise.resolve(undefined);
  return new Promise<string | undefined>((resolve) => {
    let settled = false;
    const settle = (value: string | undefined): void => {
      if (settled) return;
      settled = true;
      resolve(value);
    };
    const timer = setTimeout(() => settle(undefined), timeoutMs);
    try {
      gtag('get', measurementId, 'client_id', (clientId: unknown) => {
        clearTimeout(timer);
        settle(typeof clientId === 'string' && clientId ? clientId : undefined);
      });
    } catch {
      clearTimeout(timer);
      settle(undefined);
    }
  });
}
